import friend1 from '@/assets/friend/1.png'
import friend2 from '@/assets/friend/2.png'
import friend3 from '@/assets/friend/3.png'
import friend4 from '@/assets/friend/4.png'
import friend5 from '@/assets/friend/5.png'
import friend6 from '@/assets/friend/6.png'
import friend7 from '@/assets/friend/7.png'
import friend8 from '@/assets/friend/8.png'
import friend9 from '@/assets/friend/9.png'
import friend10 from '@/assets/friend/10.png'
import friend11 from '@/assets/friend/11.png'
import friend12 from '@/assets/friend/12.png'
import friend13 from '@/assets/friend/13.png'
import friend14 from '@/assets/friend/14.png'
import friend15 from '@/assets/friend/15.png'
import friend16 from '@/assets/friend/16.png'
import friend17 from '@/assets/friend/17.png'

export const partnerImagesGroup1 = [
    {url: friend1, id: 1},
    {url: friend2, id: 2},
    {url: friend3, id: 3},
    {url: friend4, id: 4},
    {url: friend5, id: 5},
    {url: friend6, id: 6},
    {url: friend7, id: 7}
]

export const partnerImagesGroup2 = [
    {url: friend8, id: 8},
    {url: friend9, id: 9},
    {url: friend10, id: 10},
    {url: friend11, id: 11},
    {url: friend12, id: 12},
    {url: friend13, id: 13},
    {url: friend14, id: 14},
    {url: friend15, id: 15},
    {url: friend16, id: 16},
    {url: friend17, id: 17}
]
